import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant, { ImagePreview, Lazyload, Swipe, SwipeItem } from 'vant';
import 'vant/lib/index.css';
import dayjs from 'dayjs';
import Mui from 'vue-awesome-mui';
import VConsole from 'vconsole';
import '../rem.js';

// 移动端调试工具 vConsole
new VConsole();

Vue.config.productionTip = false;
Vue.use(Mui);
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(ImagePreview);

Vue.prototype.$dayjs = dayjs;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
